const CONSTANT = {
    ERRORS: {
        ACCOUNT: {
            ACCOUNT_NOT_FOUND: 'accountNotFound',
            AUTHENTICATION_UNKNOW_ERROR: 'unknownErrorAuthenticating',
            INVALID_PASSWORD: 'invalidPassword',
            INVALID_RESET_CODE: 'invalidResetCode',
            USERNAME_ALREADY_TAKEN: 'usernameAlreadyTaken',
            UNKNOW_ERROR_AUTHENTICATING: 'unknownErrorAuthenticating',
            UNKONW_ERROR_SENDING_PASSWORD_RESET_CODE: 'unknownErrorSendingPasswordResetCode',
        },
        LOGIN: {
            INVALID_LOGIN: 'invalidLogin',
        },
    },
    LOGIN_ERROR_KEY: {
        INVALID_LOGIN: 'LOGIN.ERROR_MESSAGE.INVALID_LOGIN',
        INVALID_PASSWORD: 'LOGIN.ERROR_MESSAGE.INVALID_PASSWORD',
        UNKNOWN_ERROR: 'LOGIN.ERROR_MESSAGE.LOGIN_UNKNOWN_ERROR',
    },
    MESSAGE: {
        LEVELS: {
            ERROR: 'error',
            SUCCESS: 'success',
        },
    },
    PROFILE_ERROR_KEYS: {
        UNKNOWN_ERROR: 'LOGIN.ERROR_MESSAGE.UPDATE_PROFILE_UNKNOWN_ERROR',
    },
    PROVINCES: [
        {
            code: 'qc',
            transKey: 'LOGIN.PROVINCES.QUEBEC',
        },
        {
            code: 'on',
            transKey: 'LOGIN.PROVINCES.ONTARIO',
        },
        {
            code: 'ns',
            transKey: 'LOGIN.PROVINCES.NOVA_SCOTIA',
        },
        {
            code: 'nb',
            transKey: 'LOGIN.PROVINCES.NEW_BRUNSWICK',
        },
        {
            code: 'mb',
            transKey: 'LOGIN.PROVINCES.MANITOBA',
        },
        {
            code: 'bc',
            transKey: 'LOGIN.PROVINCES.BRITISH_COLUMBIA',
        },
        {
            code: 'pe',
            transKey: 'LOGIN.PROVINCES.PRINCE_EDWARD_ISLAND',
        },
        {
            code: 'sk',
            transKey: 'LOGIN.PROVINCES.SASKATCHEWAN',
        },
        {
            code: 'ab',
            transKey: 'LOGIN.PROVINCES.ALBERTA',
        },
        {
            code: 'nl',
            transKey: 'LOGIN.PROVINCES.NEWFOUNDLAND_AND_LABRADOR',
        },
        {
            code: 'nt',
            transKey: 'LOGIN.PROVINCES.NORTHWEST_TERRITORIES',
        },
        {
            code: 'yt',
            transKey: 'LOGIN.PROVINCES.YUKON',
        },
        {
            code: 'nu',
            transKey: 'LOGIN.PROVINCES.NUNAVUT',
        },
    ],
    QUOTE_STATUS: {
        ACTIVE: 0,
        EXPIRED: 1,
        SOLD_WITH_DEPOSIT: 4352,
        CREDIT_APPROBATION: 200960,
        F_N_I: 69888,
        CONGRATULATIONS: 3346688,
        DELIVERED_TRIAL_PERIOD: 5443840,
        DELIVERED: 1249536,
        DELIVERED_CANCELED: 5443841,
    },
    REGISTRATION_ERROR_KEYS: {
        AUTHENTICATION_ERROR: 'LOGIN.ERROR_MESSAGE.AUTHENTICATION_ERROR',
        EMAIL_ALREADY_REGISTERED: 'LOGIN.ERROR_MESSAGE.EMAIL_ALREADY_REGISTERED',
        UNKNOW_ERROR: 'LOGIN.ERROR_MESSAGE.REGISTER_UNKNOWN_ERROR',
    },
    SUCCESS: 'success',
};

export default CONSTANT;
